import React from "react";
import {
  Card,
  CardContent,
  Table,
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Stack,
} from "@mui/material";
import NoData from "components/NoData";
import { I18n } from "@aws-amplify/core";
import useMediaQuery from "@mui/material/useMediaQuery";

const DetailsCard = ({ data }) => {
  const isMobileDevice = useMediaQuery("(max-width:600px)");
  const headerCells = [
    { id: "id", label: I18n.get("Store SF ID"), align: "left", flex: 1 },
    { id: "account_number", label: I18n.get("Account Number"), align: "left", flex: 1 },
    {
      id: "name",
      label: I18n.get("Name"),
      align: "left",
      flex: 1,
      rendercell: (params) => (
        <Typography
          component="a"
          href={`https://eptarefrigeration.lightning.force.com/${params.row.id}`}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            fontSize: "medium",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          {params.value}
        </Typography>
      ),
    },
    { id: "billing_country", label: I18n.get("Country"), align: "left", flex: 1 },
    { id: "billing_country_code", label: I18n.get("Country Code"), align: "left", flex: 1 },
    { id: "billing_city", label: I18n.get("City"), align: "left", flex: 1 },
    { id: "billing_street", label: I18n.get("Street"), align: "left", flex: 1 },
    { id: "billing_postal_code", label: I18n.get("Postal Code"), align: "left", flex: 1 },
    { id: "retailer", label: I18n.get("Retailer Code"), align: "left", flex: 1 },
    { id: "retailer_description", label: I18n.get("Retailer"), align: "left", flex: 1 },

  ];

  if (!data || Object.keys(data).length === 0) {
    return (
      <Card>
        <CardContent>
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            sx={{ pb: 2 }}
          >
            <Typography variant="h5">{I18n.get("Details")}</Typography>
          </Stack>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <NoData />
          </Box>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{marginBottom:"1rem"}}>
       <CardContent sx={{ padding: "1rem", "&:last-child":{padding:"1rem"} }}>
        <Stack
          spacing={2}
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
          sx={{ pb: 2 }}
        >
          <Typography variant="h5">{I18n.get("Details")}</Typography>
        </Stack>
        <TableContainer>
          <Table>
            <TableBody>
              {headerCells.map((column, colIndex) => (
                <React.Fragment key={colIndex}>
                  <TableCell
                    style={{
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                      padding: "8px",
                      borderBottom: "1px solid #e0e0e0",
                      fontSize: "14px",
                      lineHeight: 1.6,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "15px",
                      }}
                    >
                      {column.label}:
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "14px",
                      }}
                    >
                      {column.rendercell
                        ? column.rendercell({
                            value: data[column.id],
                            row: data,
                          })
                        : data[column.id] !== undefined &&
                          data[column.id] !== null &&
                          data[column.id] !== "N/A"
                        ? data[column.id]
                        : ""}
                    </Typography>
                  </TableCell>
                  {(colIndex + 1) % (isMobileDevice ? 1 : 2) === 0 && (
                    <TableRow key={`spacer-${colIndex}`}></TableRow>
                  )}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default DetailsCard;
